// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

h1, h2, h3, h4, h5 { 
    font-family: "Lato", sans-serif;
  font-weight: 100;
  font-style: normal;
  }

.Container {
    width: 100%;
    height: auto;
    background-color: rgba(255, 255, 255, 0.8);
}

.shape1 {
    width: 40px;
    height: 80px;
    transform: skew(20deg);
    background-color: #c10230;
    background-size: 180% 180%;
    animation: gradient-animation 3s ease infinite;
    
    left: 10px;
    top: 0;
    position: fixed;
    z-index: 1;
}
    
.shape2 {
    width: 40px;
    height: 80px;
    transform: skew(20deg);
    background-color: #c10230;
    background-size: 180% 180%;
    animation: gradient-animation 3s ease infinite;
    
    right: 10px;
    bottom: 0;
    position: fixed;
    z-index: 1;
}

.Login {
    width: 100%;
    position: inherit;
    padding-top: 7%;
    padding-bottom: 7%;
    padding-left: 15%;
    padding-right: 15%;
    height: auto;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.0);
}

.Welcome {
    width: 100%;
    padding: 10%;
    box-sizing: border-box;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background-color: #c10230;
    background-size: 180% 180%;
    animation: gradient-animation 3s ease infinite;
}

.Form {
    width: 100%;
    padding: 5%;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    background-color: white;
}

.Section {
    width: 100%;
    height: auto;
    background-color: white;
}

.Header {
    width: 96%;
    height: auto;
    padding: 25px;
    margin-top: 1%;
    margin-bottom: 1%;
    margin-left: 2%;
    margin-right: 2%;
    border-radius: 15px;
    background-color: white;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);
}

.Navbar {
    width: 100%;
    height: 45px;
    padding: 10px;
    padding-left: 35px;
    margin-bottom: 20px;
    background-color: #c10230;
    /*
    background: linear-gradient(100deg,#c10230,darkviolet);
    */
}

.Article {
    width: 96%;
    min-height: 90vh;
    padding: 50px;
    margin-top: 1%;
    margin-bottom: 1%;
    margin-left: 2%;
    margin-right: 2%;
    border-radius: 15px;
    background-color: white;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);
}

.Footer {
    width: 100%;
    position: fixed;
    bottom: 0%;
    background-color: #c10230;
}


/*********************** Helpers ***********************/
.Select-Style {
    width: 80%;
    background-color: rgb(240, 240, 240);
    border: solid rgb(240, 240, 240) 1px;
    border-radius: 5px;
    padding: 5px;
    text-align: left;
    margin: 7px;
}

.Input-Style {
    width: 250px;
    background-color: rgb(240, 240, 240);
    border: solid rgb(240, 240, 240) 1px;
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    margin: 7px;
}

.Select-Style {
    width: 250px;
    background-color: rgb(240, 240, 240);
    border: solid rgb(240, 240, 240) 1px;
    border-radius: 5px;
    padding: 5px;
    text-align: left;
    margin: 7px;
}

.Button-Style {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background-color: #c10230;
    border: solid rgba(193, 2, 48, 1) 1px;
}

.Button-Inverse-Style {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background: rgba(255, 255, 255, 0.0);
    border: solid white;
}

.Invitation-Status {
    width: 100;
    height: 80px;
    border-radius: 15px;
    padding: 7%;
    box-sizing: border-box;
    background-color: white;
}

.Text-Red {
    color: rgba(193, 2, 48, 1);
}

.Text-Gray {
    color: gray;
}

.Text-left {
    text-align: left;
}

.Text-right {
    text-align: right;
}

.Display-None {
    display: none;
}

.Text-Transform-UpperCase {
    text-transform: uppercase;
}

.Chg {
    color: black;
    font-size: 30px;
    display: none;
    margin: 20px;
}

.Success-Notification {
    width: 90%;
    padding: 15px;
    background-color: rgba(71, 224, 25, 0.2);
    text-align: center;
    font-size: 19px;
    background-color: rgba(71, 224, 25, 0.2);
    border-radius: 10px;
    display: none;
}

.Error-Notification {
    width: 90%;
    padding: 15px;
    background-color: rgba(193, 2, 48, 0.2);
    text-align: center;
    font-size: 19px;
    color: rgba(193, 2, 48, 1);
    border-radius: 10px;
    display: none;
}

@keyframes gradient-animation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
}

.dt-layout-row {
    width: 100%;
}

.dt-layout-start {
    width: 50%;
    float: left;
}

.dt-layout-end {
    width: 50%;
    float: right;
}

.dt-length {
    float: left;
}

.dt-search {
    float: right;
}

#dt-length-0 {
    width: 70px;
    background-color: rgb(240, 240, 240);
    border: solid rgb(240, 240, 240) 1px;
    border-radius: 5px;
    padding: 5px;
    text-align: left;
    margin: 7px;
}

#dt-search-0 {
    width: 250px;
    background-color: rgb(240, 240, 240);
    border: solid rgb(240, 240, 240) 1px;
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    margin: 7px;
}

.paging_simple {
    float: inline-end;
}

button.dt-paging-button.disabled.previous {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background-color: #c10230;
    border: solid rgba(193, 2, 48, 1) 1px;
}

button.dt-paging-button.previous {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background-color: #c10230;
    border: solid rgba(193, 2, 48, 1) 1px;
}

button.dt-paging-button.disabled.next {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background-color: #c10230;
    border: solid rgba(193, 2, 48, 1) 1px;
}

button.dt-paging-button.next {
    width: 150px;
    height: auto;
    padding: 8px;
    border-radius: 20px;
    color: white;
    margin: 10px;
    background-color: #c10230;
    border: solid rgba(193, 2, 48, 1) 1px;
}

/*********************** Media querys ***********************/
@media (max-width: 990px) {
    .gone {
        display: none; }

    .Login {
        padding: 0%; }
    
    .Form {
        padding-top: 20%;
        padding-bottom: 20%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,+BAA+B;EACjC,gBAAgB;EAChB,kBAAkB;EAClB;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,8CAA8C;;IAE9C,UAAU;IACV,MAAM;IACN,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,8CAA8C;;IAE9C,WAAW;IACX,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IAGtB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB;;KAEC;AACL;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IAGtB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;;AAGA,wDAAwD;AACxD;IACI,UAAU;IACV,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;MACE,2BAA2B;IAC7B;IACA;MACE,6BAA6B;IAC/B;IACA;MACE,2BAA2B;IAC7B;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,6DAA6D;AAC7D;IACI;QACI,aAAa,EAAE;;IAEnB;QACI,WAAW,EAAE;;IAEjB;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nh1, h2, h3, h4, h5 { \r\n    font-family: \"Lato\", sans-serif;\r\n  font-weight: 100;\r\n  font-style: normal;\r\n  }\r\n\r\n.Container {\r\n    width: 100%;\r\n    height: auto;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.shape1 {\r\n    width: 40px;\r\n    height: 80px;\r\n    transform: skew(20deg);\r\n    background-color: #c10230;\r\n    background-size: 180% 180%;\r\n    animation: gradient-animation 3s ease infinite;\r\n    \r\n    left: 10px;\r\n    top: 0;\r\n    position: fixed;\r\n    z-index: 1;\r\n}\r\n    \r\n.shape2 {\r\n    width: 40px;\r\n    height: 80px;\r\n    transform: skew(20deg);\r\n    background-color: #c10230;\r\n    background-size: 180% 180%;\r\n    animation: gradient-animation 3s ease infinite;\r\n    \r\n    right: 10px;\r\n    bottom: 0;\r\n    position: fixed;\r\n    z-index: 1;\r\n}\r\n\r\n.Login {\r\n    width: 100%;\r\n    position: inherit;\r\n    padding-top: 7%;\r\n    padding-bottom: 7%;\r\n    padding-left: 15%;\r\n    padding-right: 15%;\r\n    height: auto;\r\n    border-radius: 15px;\r\n    background-color: rgba(255, 255, 255, 0.0);\r\n}\r\n\r\n.Welcome {\r\n    width: 100%;\r\n    padding: 10%;\r\n    box-sizing: border-box;\r\n    border-top-left-radius: 15px;\r\n    border-bottom-left-radius: 15px;\r\n    background-color: #c10230;\r\n    background-size: 180% 180%;\r\n    animation: gradient-animation 3s ease infinite;\r\n}\r\n\r\n.Form {\r\n    width: 100%;\r\n    padding: 5%;\r\n    border-top-right-radius: 15px;\r\n    border-bottom-right-radius: 15px;\r\n    background-color: white;\r\n}\r\n\r\n.Section {\r\n    width: 100%;\r\n    height: auto;\r\n    background-color: white;\r\n}\r\n\r\n.Header {\r\n    width: 96%;\r\n    height: auto;\r\n    padding: 25px;\r\n    margin-top: 1%;\r\n    margin-bottom: 1%;\r\n    margin-left: 2%;\r\n    margin-right: 2%;\r\n    border-radius: 15px;\r\n    background-color: white;\r\n    box-sizing: border-box;\r\n    -webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n    -moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n}\r\n\r\n.Navbar {\r\n    width: 100%;\r\n    height: 45px;\r\n    padding: 10px;\r\n    padding-left: 35px;\r\n    margin-bottom: 20px;\r\n    background-color: #c10230;\r\n    /*\r\n    background: linear-gradient(100deg,#c10230,darkviolet);\r\n    */\r\n}\r\n\r\n.Article {\r\n    width: 96%;\r\n    min-height: 90vh;\r\n    padding: 50px;\r\n    margin-top: 1%;\r\n    margin-bottom: 1%;\r\n    margin-left: 2%;\r\n    margin-right: 2%;\r\n    border-radius: 15px;\r\n    background-color: white;\r\n    box-sizing: border-box;\r\n    -webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n    -moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.25);\r\n}\r\n\r\n.Footer {\r\n    width: 100%;\r\n    position: fixed;\r\n    bottom: 0%;\r\n    background-color: #c10230;\r\n}\r\n\r\n\r\n/*********************** Helpers ***********************/\r\n.Select-Style {\r\n    width: 80%;\r\n    background-color: rgb(240, 240, 240);\r\n    border: solid rgb(240, 240, 240) 1px;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    text-align: left;\r\n    margin: 7px;\r\n}\r\n\r\n.Input-Style {\r\n    width: 250px;\r\n    background-color: rgb(240, 240, 240);\r\n    border: solid rgb(240, 240, 240) 1px;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    text-align: center;\r\n    margin: 7px;\r\n}\r\n\r\n.Select-Style {\r\n    width: 250px;\r\n    background-color: rgb(240, 240, 240);\r\n    border: solid rgb(240, 240, 240) 1px;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    text-align: left;\r\n    margin: 7px;\r\n}\r\n\r\n.Button-Style {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background-color: #c10230;\r\n    border: solid rgba(193, 2, 48, 1) 1px;\r\n}\r\n\r\n.Button-Inverse-Style {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background: rgba(255, 255, 255, 0.0);\r\n    border: solid white;\r\n}\r\n\r\n.Invitation-Status {\r\n    width: 100;\r\n    height: 80px;\r\n    border-radius: 15px;\r\n    padding: 7%;\r\n    box-sizing: border-box;\r\n    background-color: white;\r\n}\r\n\r\n.Text-Red {\r\n    color: rgba(193, 2, 48, 1);\r\n}\r\n\r\n.Text-Gray {\r\n    color: gray;\r\n}\r\n\r\n.Text-left {\r\n    text-align: left;\r\n}\r\n\r\n.Text-right {\r\n    text-align: right;\r\n}\r\n\r\n.Display-None {\r\n    display: none;\r\n}\r\n\r\n.Text-Transform-UpperCase {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.Chg {\r\n    color: black;\r\n    font-size: 30px;\r\n    display: none;\r\n    margin: 20px;\r\n}\r\n\r\n.Success-Notification {\r\n    width: 90%;\r\n    padding: 15px;\r\n    background-color: rgba(71, 224, 25, 0.2);\r\n    text-align: center;\r\n    font-size: 19px;\r\n    background-color: rgba(71, 224, 25, 0.2);\r\n    border-radius: 10px;\r\n    display: none;\r\n}\r\n\r\n.Error-Notification {\r\n    width: 90%;\r\n    padding: 15px;\r\n    background-color: rgba(193, 2, 48, 0.2);\r\n    text-align: center;\r\n    font-size: 19px;\r\n    color: rgba(193, 2, 48, 1);\r\n    border-radius: 10px;\r\n    display: none;\r\n}\r\n\r\n@keyframes gradient-animation {\r\n    0% {\r\n      background-position: 0% 50%;\r\n    }\r\n    50% {\r\n      background-position: 100% 50%;\r\n    }\r\n    100% {\r\n      background-position: 0% 50%;\r\n    }\r\n}\r\n\r\n.dt-layout-row {\r\n    width: 100%;\r\n}\r\n\r\n.dt-layout-start {\r\n    width: 50%;\r\n    float: left;\r\n}\r\n\r\n.dt-layout-end {\r\n    width: 50%;\r\n    float: right;\r\n}\r\n\r\n.dt-length {\r\n    float: left;\r\n}\r\n\r\n.dt-search {\r\n    float: right;\r\n}\r\n\r\n#dt-length-0 {\r\n    width: 70px;\r\n    background-color: rgb(240, 240, 240);\r\n    border: solid rgb(240, 240, 240) 1px;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    text-align: left;\r\n    margin: 7px;\r\n}\r\n\r\n#dt-search-0 {\r\n    width: 250px;\r\n    background-color: rgb(240, 240, 240);\r\n    border: solid rgb(240, 240, 240) 1px;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    text-align: center;\r\n    margin: 7px;\r\n}\r\n\r\n.paging_simple {\r\n    float: inline-end;\r\n}\r\n\r\nbutton.dt-paging-button.disabled.previous {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background-color: #c10230;\r\n    border: solid rgba(193, 2, 48, 1) 1px;\r\n}\r\n\r\nbutton.dt-paging-button.previous {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background-color: #c10230;\r\n    border: solid rgba(193, 2, 48, 1) 1px;\r\n}\r\n\r\nbutton.dt-paging-button.disabled.next {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background-color: #c10230;\r\n    border: solid rgba(193, 2, 48, 1) 1px;\r\n}\r\n\r\nbutton.dt-paging-button.next {\r\n    width: 150px;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 20px;\r\n    color: white;\r\n    margin: 10px;\r\n    background-color: #c10230;\r\n    border: solid rgba(193, 2, 48, 1) 1px;\r\n}\r\n\r\n/*********************** Media querys ***********************/\r\n@media (max-width: 990px) {\r\n    .gone {\r\n        display: none; }\r\n\r\n    .Login {\r\n        padding: 0%; }\r\n    \r\n    .Form {\r\n        padding-top: 20%;\r\n        padding-bottom: 20%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
